import { composeFieldPath } from '@northfork/basics'

export interface ExternalTransactionDetailsModel {
  property: string
  custodyValue: string
  tradeSystemValue: string
}

export interface CwTransactionDetailsModel {
  property: string
  value: string
  key: string
}

export interface TpiDataModel {
  property: string
  value: string
}

export const externalTransactionDetailsField = composeFieldPath(
  [] as ExternalTransactionDetailsModel[],
)

export const cwTransactionDetailsField = composeFieldPath(
  [] as CwTransactionDetailsModel[],
)

export const tpiDataField = composeFieldPath([] as TpiDataModel[])
